// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".HeaderMenu[data-v-08d0297a]{margin-right:.3rem;height:70%}.HeaderMenu_icon[data-v-08d0297a]{width:100%;height:100%;display:block;font-size:1rem}.nav[data-v-08d0297a]{margin-top:.4rem}", ""]);
// Exports
module.exports = exports;
